unit View.Csosn.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewCsosnEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbcsosn_id: TLabel;
    edcsosn_id: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientCsosnGet: TXDataWebClient;
    XDataClientCsosnDelete: TXDataWebClient;
    CsosnDataset: TXDataWebDataSet;
    CsosnDatasetcsosn_id: TStringField;
    CsosnDatasetnome: TStringField;
    CsosnDatasetexcluido: TBooleanField;
    CsosnDatasetinclusao: TDateTimeField;
    CsosnDatasetalteracao: TDateTimeField;
    CsosnDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientCsosnGetLoad(Response: TXDataClientResponse);
    procedure XDataClientCsosnDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientCsosnDeleteError(Error: TXDataClientError);
    procedure CsosnDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewCsosnEdit: TFViewCsosnEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewCsosnEdit }

procedure TFViewCsosnEdit.btSaveClick(Sender: TObject);
begin
  if CsosnDataset.State in dsEditModes then
  begin
        CsosnDataset.Post;
    CsosnDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewCsosnEdit.btDeleteClick(Sender: TObject);
begin
  if CsosnDataset.State in dsEditModes then
    CsosnDataset.Post;
  XDataClientCsosnDelete.Delete(CsosnDataset.EntitySetName,
    TJSObject(CsosnDataset.CurrentData));
end;


class function TFViewCsosnEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewCsosnEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewCsosnEdit.InsertEntity;
begin
  CsosnDataset.Close;
  CsosnDataset.SetJsonData('{}');
  CsosnDataset.Open;
  CsosnDataset.Insert;
end;

class function TFViewCsosnEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewCsosnEdit(AForm).FInserting := AInserting;
    TFViewCsosnEdit(AForm).FId := AId;
    TFViewCsosnEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewCsosnEdit(AForm).InsertEntity
    else
      TFViewCsosnEdit(AForm).LoadEntity;
    TFViewCsosnEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewCsosnEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewCsosnEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    CsosnDataset.Connection.Model.DefaultSchema.FindEntityType(
      CsosnDataset.EntitySetName
    )
  );
  XDataClientCsosnGet.Get(CsosnDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewCsosnEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewCsosnEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewCsosnEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewCsosnEdit.XDataClientCsosnGetLoad(Response: TXDataClientResponse);
begin
  CsosnDataset.Close;
  CsosnDataset.SetJsonData(Response.Result);
  CsosnDataset.Open;
  
  CsosnDataset.Edit;  
end;

procedure TFViewCsosnEdit.XDataClientCsosnDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewCsosnEdit.XDataClientCsosnDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewCsosnEdit.CsosnDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewCsosnEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewCsosnEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.csosn.form.message');
  lbMessage := TLabel.Create('view.csosn.form.message.label');
  btCloseMessage := TButton.Create('view.csosn.form.message.button');
  btCancel := TButton.Create('view.csosn.form.btBack');
  btSave := TButton.Create('view.csosn.form.btSave');
  btDelete := TButton.Create('view.csosn.form.btDelete');
  lbcsosn_id := TLabel.Create('view.csosn.form.lbcsosn_id');
  edcsosn_id := TDBEdit.Create('view.csosn.form.edcsosn_id');
  lbnome := TLabel.Create('view.csosn.form.lbnome');
  ednome := TDBEdit.Create('view.csosn.form.ednome');
  lbexcluido := TLabel.Create('view.csosn.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.csosn.form.edexcluido');
  lbinclusao := TLabel.Create('view.csosn.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.csosn.form.edinclusao');
  lbalteracao := TLabel.Create('view.csosn.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.csosn.form.edalteracao');
  lbexclusao := TLabel.Create('view.csosn.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.csosn.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  CsosnDataset := TXDataWebDataSet.Create(Self);
  CsosnDatasetcsosn_id := TStringField.Create(Self);
  CsosnDatasetnome := TStringField.Create(Self);
  CsosnDatasetexcluido := TBooleanField.Create(Self);
  CsosnDatasetinclusao := TDateTimeField.Create(Self);
  CsosnDatasetalteracao := TDateTimeField.Create(Self);
  CsosnDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientCsosnGet := TXDataWebClient.Create(Self);
  XDataClientCsosnDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbcsosn_id.BeforeLoadDFMValues;
  edcsosn_id.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  CsosnDataset.BeforeLoadDFMValues;
  CsosnDatasetcsosn_id.BeforeLoadDFMValues;
  CsosnDatasetnome.BeforeLoadDFMValues;
  CsosnDatasetexcluido.BeforeLoadDFMValues;
  CsosnDatasetinclusao.BeforeLoadDFMValues;
  CsosnDatasetalteracao.BeforeLoadDFMValues;
  CsosnDatasetexclusao.BeforeLoadDFMValues;
  XDataClientCsosnGet.BeforeLoadDFMValues;
  XDataClientCsosnDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewCsosnEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 427;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 367;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 367;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 367;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbcsosn_id.SetParentComponent(Self);
    lbcsosn_id.Name := 'lbcsosn_id';
    lbcsosn_id.Left := 24;
    lbcsosn_id.Top := 192;
    lbcsosn_id.Width := 14;
    lbcsosn_id.Height := 13;
    lbcsosn_id.Caption := 'csosn_id:';
    lbcsosn_id.Transparent := True;
    edcsosn_id.SetParentComponent(Self);
    edcsosn_id.Name := 'edcsosn_id';
    edcsosn_id.Left := 221;
    edcsosn_id.Top := 189;
    edcsosn_id.Width := 200;
    edcsosn_id.Height := 21;
    edcsosn_id.Enabled := True;
    edcsosn_id.TabOrder := 6;
    edcsosn_id.Text := 'edcsosn_id';
    edcsosn_id.DataField := 'csosn_id';
    edcsosn_id.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 219;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 216;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 7;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 246;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 243;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 8;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 273;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 270;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 9;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 300;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 297;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 10;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 327;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 324;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 11;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := CsosnDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    CsosnDataset.SetParentComponent(Self);
    CsosnDataset.Name := 'CsosnDataset';
    CsosnDataset.AfterApplyUpdates := CsosnDatasetAfterApplyUpdates;
    CsosnDataset.EntitySetName := 'Csosn';
    CsosnDataset.Connection := DMConnection.ApiConnection;
    CsosnDataset.Left := 176;
    CsosnDataset.Top := 8;
    CsosnDatasetcsosn_id.SetParentComponent(CsosnDataset);
    CsosnDatasetcsosn_id.Name := 'CsosnDatasetcsosn_id';
    CsosnDatasetcsosn_id.FieldName := 'csosn_id';
    CsosnDatasetcsosn_id.Required := True;
    CsosnDatasetcsosn_id.Size := 255;
    CsosnDatasetnome.SetParentComponent(CsosnDataset);
    CsosnDatasetnome.Name := 'CsosnDatasetnome';
    CsosnDatasetnome.FieldName := 'nome';
    CsosnDatasetnome.Required := True;
    CsosnDatasetnome.Size := 255;
    CsosnDatasetexcluido.SetParentComponent(CsosnDataset);
    CsosnDatasetexcluido.Name := 'CsosnDatasetexcluido';
    CsosnDatasetexcluido.FieldName := 'excluido';
    CsosnDatasetexcluido.Required := False;
    CsosnDatasetinclusao.SetParentComponent(CsosnDataset);
    CsosnDatasetinclusao.Name := 'CsosnDatasetinclusao';
    CsosnDatasetinclusao.FieldName := 'inclusao';
    CsosnDatasetinclusao.Required := False;
    CsosnDatasetalteracao.SetParentComponent(CsosnDataset);
    CsosnDatasetalteracao.Name := 'CsosnDatasetalteracao';
    CsosnDatasetalteracao.FieldName := 'alteracao';
    CsosnDatasetalteracao.Required := False;
    CsosnDatasetexclusao.SetParentComponent(CsosnDataset);
    CsosnDatasetexclusao.Name := 'CsosnDatasetexclusao';
    CsosnDatasetexclusao.FieldName := 'exclusao';
    CsosnDatasetexclusao.Required := False;
    XDataClientCsosnGet.SetParentComponent(Self);
    XDataClientCsosnGet.Name := 'XDataClientCsosnGet';
    XDataClientCsosnGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientCsosnGet, Self, 'OnLoad', 'XDataClientCsosnGetLoad');
    XDataClientCsosnGet.Left := 64;
    XDataClientCsosnGet.Top := 8;
    XDataClientCsosnDelete.SetParentComponent(Self);
    XDataClientCsosnDelete.Name := 'XDataClientCsosnDelete';
    XDataClientCsosnDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientCsosnDelete, Self, 'OnLoad', 'XDataClientCsosnDeleteLoad');
    SetEvent(XDataClientCsosnDelete, Self, 'OnError', 'XDataClientCsosnDeleteError');
    XDataClientCsosnDelete.Left := 64;
    XDataClientCsosnDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbcsosn_id.AfterLoadDFMValues;
    edcsosn_id.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    CsosnDataset.AfterLoadDFMValues;
    CsosnDatasetcsosn_id.AfterLoadDFMValues;
    CsosnDatasetnome.AfterLoadDFMValues;
    CsosnDatasetexcluido.AfterLoadDFMValues;
    CsosnDatasetinclusao.AfterLoadDFMValues;
    CsosnDatasetalteracao.AfterLoadDFMValues;
    CsosnDatasetexclusao.AfterLoadDFMValues;
    XDataClientCsosnGet.AfterLoadDFMValues;
    XDataClientCsosnDelete.AfterLoadDFMValues;
  end;
end;

end.
